import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import hi from './locales/hi.json';
import { useLanguageStore } from '../store/langStore';

const resources = {
  en: { translation: en },
  hi: { translation: hi },
} as const;

const initialLang =
  useLanguageStore.getState().appLang || 'en';
i18n
  .use(initReactI18next)
  .init({
    resources,
    lng:  initialLang || 'en',
    fallbackLng: 'en',
    compatibilityJSON: 'v4',
    interpolation: {
      escapeValue: false, // React handles escaping
    },
  });

export default i18n;
